"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createServerOrPathString = void 0;
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
function createServerOrPathString(database) {
    switch (database.__typename) {
        case 'CloudFile':
            return getStringForCloudFile(database);
        case 'DataCloud':
            return ''; // Need to replace with actual implementation
        case 'DatabaseServer':
            // Values can be null or undefined. When values are null, that means that the value has been obfuscated. When the value is undefined
            // that means the attribute doesn't exist. We need to handle both of those cases here.
            if (database.name === undefined && database.hostName === undefined) {
                return '';
            }
            else if (database.name === undefined && database.hostName !== undefined) {
                // We return the full permissions required string if hostName is null for obfuscation
                return database.hostName !== null ? database.hostName : catalog_messages_1.Messages.DatabaseWithHostname({
                    databaseName: catalog_messages_1.Messages.PermissionRequired(),
                    databaseHostName: catalog_messages_1.Messages.PermissionsRequired(),
                });
            }
            else if (database.name !== undefined && database.hostName === undefined) {
                // We return the full permissions required string if name is null for obfuscation
                return database.name !== null ? database.name : catalog_messages_1.Messages.DatabaseWithHostname({
                    databaseName: catalog_messages_1.Messages.PermissionRequired(),
                    databaseHostName: catalog_messages_1.Messages.PermissionsRequired(),
                });
            }
            else {
                return catalog_messages_1.Messages.DatabaseWithHostname({
                    databaseName: database.name !== null ? database.name : catalog_messages_1.Messages.PermissionsRequired(),
                    databaseHostName: database.hostName !== null ? database.hostName : catalog_messages_1.Messages.PermissionsRequired(),
                });
            }
        case 'File':
            // Values can be null or undefined. When values are null, that means that the value has been obfuscated. When the value is undefined
            // that means the attribute doesn't exist. We need to handle both of those cases here.
            if (database.filePath === undefined) {
                return '';
            }
            return database.filePath !== null ? database.filePath : catalog_messages_1.Messages.PermissionsRequired();
        case 'WebDataConnector':
            // Values can be null or undefined. When values are null, that means that the value has been obfuscated. When the value is undefined
            // that means the attribute doesn't exist. We need to handle both of those cases here.
            if (database.connectorUrl === undefined) {
                return '';
            }
            return database.connectorUrl !== null ? database.connectorUrl : catalog_messages_1.Messages.PermissionsRequired();
        default:
            (0, catalog_core_1.assertUnreachable)(database);
            return '';
    }
}
exports.createServerOrPathString = createServerOrPathString;
function getStringForCloudFile(database) {
    if (database.requestUrl) {
        return database.requestUrl;
    }
    else if (database.provider && database.fileId) {
        return `${database.provider} ${database.fileId}`;
    }
    else if (database.provider) {
        return database.provider;
    }
    else if (database.fileId) {
        return database.fileId;
    }
    else {
        return '';
    }
}
//# sourceMappingURL=ServerOrPathCell.js.map